var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PreviewPlayer } from "../PlayerPreview";
import { Box } from "@chakra-ui/react";
import { v4 } from "uuid";
export const AddPreview = (_a) => {
    var { onClick, widgetWidth, screenheight } = _a, rest = __rest(_a, ["onClick", "widgetWidth", "screenheight"]);
    const data = {
        id: v4(),
        data: {
            text: "Défilement de texte",
            font: "Lobster",
            size: Math.round(screenheight * 0.05),
            fontWeight: 400,
            textColor: "#ffffff",
            backgroundColor: "#33333300",
            scrollSpeed: 3,
        },
    };
    const layoutItem = {
        id: v4(),
        height: "0",
        width: widgetWidth.toString(),
        name: "Défilement",
        unit: "%",
        widget: Object.assign(Object.assign({}, data), { data: Object.assign(Object.assign({}, data.data), { size: 20, backgroundColor: "#333333" }) }),
        widgetName: "Défilement",
        x: "0",
        y: "0",
        z: 0,
    };
    return (React.createElement(Box, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(PreviewPlayer, { layoutItem: layoutItem, scale: 1 })));
};
